var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "view-container" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "application-container",
      },
      [
        _c(
          "div",
          { staticClass: "logo flex items-center justify-center relative" },
          [
            _c(
              "i",
              {
                staticClass: "el-icon-arrow-left absolute",
                on: { click: _vm.handleBackLogin },
              },
              [_vm._v("返回")]
            ),
            _c("span", [_vm._v("申请试用账号")]),
          ]
        ),
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "application-form",
            attrs: { model: _vm.form, rules: _vm.rules, "label-width": "76px" },
          },
          [
            [
              _c(
                "el-form-item",
                { attrs: { prop: "nickname", label: "姓名" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入姓名" },
                    model: {
                      value: _vm.form.nickname,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "nickname", $$v)
                      },
                      expression: "form.nickname",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "org", label: "单位" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入单位" },
                    model: {
                      value: _vm.form.org,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "org", $$v)
                      },
                      expression: "form.org",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "select-box",
                  staticStyle: { width: "70%" },
                  attrs: { prop: "identity", label: "身份" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择身份" },
                      model: {
                        value: _vm.form.identity,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "identity", $$v)
                        },
                        expression: "form.identity",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { value: "技术经理人", label: "技术经理人" },
                      }),
                      _c("el-option", {
                        attrs: { value: "企业研发人员", label: "企业研发人员" },
                      }),
                      _c("el-option", {
                        attrs: { value: "科研人员", label: "科研人员" },
                      }),
                      _c("el-option", {
                        attrs: { value: "其他", label: "其他" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "phone", label: "手机号" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入手机号" },
                    model: {
                      value: _vm.form.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "code", label: "验证码" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "flex items-center", attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 15 } },
                        [
                          _c("el-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "请输入验证码",
                            },
                            model: {
                              value: _vm.form.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "code", $$v)
                              },
                              expression: "form.code",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 9 } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "code-btn",
                              attrs: { disabled: !_vm.canSendCode },
                              on: { click: _vm.getVerifyCode },
                            },
                            [_vm._v(" " + _vm._s(_vm.codeBtnText) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "email", label: "邮箱" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入邮箱" },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "password", label: "密码" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      autocomplete: "new-password",
                      placeholder: "请输入密码",
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "checkPass", label: "确认密码" } },
                [
                  _c("el-input", {
                    attrs: {
                      "show-password": "",
                      autocomplete: "new-confirm-password",
                      placeholder: "请再次输入密码",
                    },
                    model: {
                      value: _vm.form.checkPass,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "checkPass", $$v)
                      },
                      expression: "form.checkPass",
                    },
                  }),
                ],
                1
              ),
            ],
            _c(
              "el-button",
              {
                staticClass: "submit-btn",
                attrs: { type: "primary" },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v(" 提交 ")]
            ),
            _c("p", { staticClass: "tips" }, [
              _vm._v(
                "注：审核通过后，将通过短信通知您；后续请通过手机号+验证码/密码的形式登录"
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }